import axiosRoot from "axios";
import { getBaseUrl } from "./config/base-url";

const axios = axiosRoot.create({ baseURL: getBaseUrl() });

axios.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong!"
    )
);

function extractPortNumber(str) {
  const regex = /port=(\d+)/;
  const match = str.match(regex);
  if (match) {
    return parseInt(match[1]);
  } else {
    return null;
  }
}


// make root axios
let rootBaseUrl = String(getBaseUrl()).replace('/api/administration', '');
const rootAxios = axiosRoot.create({ baseURL: rootBaseUrl })
rootAxios.interceptors.request.use(req => {

  if (String(window.location.href).includes('localhost')) {
    const port = extractPortNumber(req.url);
    req.baseURL = String(rootBaseUrl).replace('5000', port)
  }

  // rootAxios is a separate instance from the default axios, so the global
  // Authorization default isn't applied here — attach the admin token so the
  // notification campaign endpoints (which require auth) accept the request.
  const accessToken = typeof window !== 'undefined' ? window.localStorage.getItem('accessToken') : null;
  if (accessToken) {
    req.headers.Authorization = `Bearer ${accessToken}`;
  }

  return req;
})

rootAxios.interceptors.response.use(res => {
  return res;
})


export { rootAxios }

export default axios;


